import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/en/services", "en", "services");
